import React, { useEffect } from "react"

type ClickAwayDivProps = {
  children: React.ReactNode
  containerClassName?: string
  handleClickOutside: (event: MouseEvent) => void
}

export const ClickAwayDiv = React.forwardRef<HTMLDivElement, ClickAwayDivProps>(
  ({ children, containerClassName, handleClickOutside }, ref) => {
    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside)
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [handleClickOutside])

    return (
      <div className={containerClassName} ref={ref}>
        {children}
      </div>
    )
  },
)

ClickAwayDiv.displayName = "ClickAwayDiv"
